// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.catalog-top-head {
  display: flex; align-items: center; gap: 12px;
  padding: 12px 20px; background: var(--cream);
  border-bottom: 1px solid var(--light-gray);
  position: sticky; top: 0; z-index: 190;
}
.back-btn { color: var(--burgundy); background: none; border: none; cursor: pointer; padding: 4px; }
.catalog-logo {
  font-family: var(--font-display); font-size: 22px;
  color: var(--burgundy); letter-spacing: 3px; cursor: pointer; font-weight: 600;
}
.catalog-heading-label {
  font-size: 13px; color: var(--gray); letter-spacing: 1px; text-transform: uppercase;
  margin-left: auto;
}

.catalog-page-grid {
  display: grid; grid-template-columns: repeat(2, 1fr);
  gap: 16px; padding: 20px;
  max-width: 1200px; margin: 0 auto;
}
@media (min-width: 600px) { .catalog-page-grid { grid-template-columns: repeat(3, 1fr); } }
@media (min-width: 900px) { .catalog-page-grid { grid-template-columns: repeat(4, 1fr); } }

.no-results {
  grid-column: 1 / -1; text-align: center;
  padding: 60px 20px; color: var(--gray); font-size: 15px;
}

.load-more-wrap { display: flex; justify-content: center; padding: 24px; }
.loading-bar {
  height: 3px; background: var(--gradient-primary);
  animation: loading 1s infinite;
}
@keyframes loading { 0% { width: 0; } 100% { width: 100%; } }

/* ---- Mobile (phones ~320-430px) ---- */
@media (max-width: 600px) {
  .catalog-top-head {
    gap: 8px;
    padding: 12px 14px;
    flex-wrap: wrap;
  }
  .catalog-logo { font-size: 18px; letter-spacing: 2px; }
  /* Let the label wrap to its own line rather than overflow the row */
  .catalog-heading-label {
    font-size: 11px;
    flex-basis: 100%;
    margin-left: 0;
    text-align: left;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/CatalogPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa,EAAE,mBAAmB,EAAE,SAAS;EAC7C,kBAAkB,EAAE,wBAAwB;EAC5C,0CAA0C;EAC1C,gBAAgB,EAAE,MAAM,EAAE,YAAY;AACxC;AACA,YAAY,sBAAsB,EAAE,gBAAgB,EAAE,YAAY,EAAE,eAAe,EAAE,YAAY,EAAE;AACnG;EACE,gCAAgC,EAAE,eAAe;EACjD,sBAAsB,EAAE,mBAAmB,EAAE,eAAe,EAAE,gBAAgB;AAChF;AACA;EACE,eAAe,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,yBAAyB;EACnF,iBAAiB;AACnB;;AAEA;EACE,aAAa,EAAE,qCAAqC;EACpD,SAAS,EAAE,aAAa;EACxB,iBAAiB,EAAE,cAAc;AACnC;AACA,4BAA4B,qBAAqB,qCAAqC,EAAE,EAAE;AAC1F,4BAA4B,qBAAqB,qCAAqC,EAAE,EAAE;;AAE1F;EACE,mBAAmB,EAAE,kBAAkB;EACvC,kBAAkB,EAAE,kBAAkB,EAAE,eAAe;AACzD;;AAEA,kBAAkB,aAAa,EAAE,uBAAuB,EAAE,aAAa,EAAE;AACzE;EACE,WAAW,EAAE,mCAAmC;EAChD,8BAA8B;AAChC;AACA,qBAAqB,KAAK,QAAQ,EAAE,EAAE,OAAO,WAAW,EAAE,EAAE;;AAE5D,yCAAyC;AACzC;EACE;IACE,QAAQ;IACR,kBAAkB;IAClB,eAAe;EACjB;EACA,gBAAgB,eAAe,EAAE,mBAAmB,EAAE;EACtD,oEAAoE;EACpE;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;EAClB;AACF","sourcesContent":[".catalog-top-head {\n  display: flex; align-items: center; gap: 12px;\n  padding: 12px 20px; background: var(--cream);\n  border-bottom: 1px solid var(--light-gray);\n  position: sticky; top: 0; z-index: 190;\n}\n.back-btn { color: var(--burgundy); background: none; border: none; cursor: pointer; padding: 4px; }\n.catalog-logo {\n  font-family: var(--font-display); font-size: 22px;\n  color: var(--burgundy); letter-spacing: 3px; cursor: pointer; font-weight: 600;\n}\n.catalog-heading-label {\n  font-size: 13px; color: var(--gray); letter-spacing: 1px; text-transform: uppercase;\n  margin-left: auto;\n}\n\n.catalog-page-grid {\n  display: grid; grid-template-columns: repeat(2, 1fr);\n  gap: 16px; padding: 20px;\n  max-width: 1200px; margin: 0 auto;\n}\n@media (min-width: 600px) { .catalog-page-grid { grid-template-columns: repeat(3, 1fr); } }\n@media (min-width: 900px) { .catalog-page-grid { grid-template-columns: repeat(4, 1fr); } }\n\n.no-results {\n  grid-column: 1 / -1; text-align: center;\n  padding: 60px 20px; color: var(--gray); font-size: 15px;\n}\n\n.load-more-wrap { display: flex; justify-content: center; padding: 24px; }\n.loading-bar {\n  height: 3px; background: var(--gradient-primary);\n  animation: loading 1s infinite;\n}\n@keyframes loading { 0% { width: 0; } 100% { width: 100%; } }\n\n/* ---- Mobile (phones ~320-430px) ---- */\n@media (max-width: 600px) {\n  .catalog-top-head {\n    gap: 8px;\n    padding: 12px 14px;\n    flex-wrap: wrap;\n  }\n  .catalog-logo { font-size: 18px; letter-spacing: 2px; }\n  /* Let the label wrap to its own line rather than overflow the row */\n  .catalog-heading-label {\n    font-size: 11px;\n    flex-basis: 100%;\n    margin-left: 0;\n    text-align: left;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
